
import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator"

import { utils } from "@/mixins/utils"

// @ts-ignore
import QRCode from "qrcode"

// @ts-ignore
import speakeasy from "speakeasy"

import api from "@/services/api"
import { AuthSetup } from "@/types/user"

@Component({
	components: {}
})
export default class MFASetup extends Vue {
    @Prop({ default: "" })
	public email!: string

    @Prop({ default: null })
	public tenantName!: string | null

    @Prop({ default: () => null })
	public error!: string | null

    @Prop({ default: () => null })
	public value!: AuthSetup | null

	@Prop({ default: false })
	public mfaSet!: boolean

	@Ref()
	readonly mfaContainer: any;

	private tempSecret: string | null = null
	private otpURL: string | null = null
	private qrDataUrl: string | null = null

	private localAuthCode: string | null = null

	get currentValue (): AuthSetup {
		return {
			authCode: this.localAuthCode,
			token: this.tempSecret
		}
	}

	get isValid (): boolean {
		return !!this.localAuthCode && !!this.tempSecret
	}

	@Watch("isValid")
	onValidChanged (newValue: boolean) {
		this.$emit("valid", newValue)
	}

	@Watch("currentValue", { deep: true })
	onValueChanged (newValue: AuthSetup) {
		this.$emit("input", newValue)
	}

	public mounted () {
		// Create our MFA QR code
		const secret = speakeasy.generateSecret({
			length: 20,
			name: this.tenantName ? `Sureview Cases (${this.tenantName})` : "Sureview Cases",
			issuer: "Sureview Cases"
		})

		this.tempSecret = secret.base32
		this.otpURL = secret.otpauth_url

		QRCode.toDataURL(secret.otpauth_url, (err: Error | null, dataUrl: string | undefined) => {
			if (err) {
				console.error("Error generating QR code:", err)
				return null
			}

			this.qrDataUrl = dataUrl ?? null
		})
	}

	private copySecretToClipboard () {
		if (!this.tempSecret) return
		utils.methods.copyToClipboard(this.mfaContainer, this.tempSecret as string)
	}
}

